module.exports = __webpack_public_path__ + "img/badge-color.51fbe6fd.png";